import { DeploymentType } from "@/api";
import App from "./App";

interface Props {
  shareAppId: string;
  appSearchParams?: Record<string, unknown>;
}

function ShareApp({ shareAppId, appSearchParams }: Props) {
  return (
    <App
      deploymentId={shareAppId}
      deploymentType={DeploymentType.Shared}
      loading={false}
      releaseNotesBase64={undefined}
      userGuideBase64={undefined}
      appSearchParams={appSearchParams}
    />
  );
}

export default ShareApp;
